const getters = {
    sidebar: state => state.app.sidebar,
    device: state => state.app.device,
    token: state => state.user.token,
    icon: state => state.user.icon,
    name: state => state.user.name,
    uuid: state =>state.user.uuid,
    routers:state =>state.user.routers,
    isLogin:state => state.user.isLogin,
    userInfo:state => state.user.userInfo,
    permission:state =>state.user.permission,
    passwordExpired: state => state.user.passwordExpired,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js